module.exports = __webpack_public_path__ + "img/radiologic-technology.87cf92b6.png";